'use client'

import { AddToCartButton, FreeDownloadButton } from '@/AddToCartButton'
import { Button } from '@/General/Button'
import type { GroupChildProductForCart } from '@/lib/groupChildCart'
import type { RegionalBrandCode } from '@/lib/seo/marketUrls'

export const ProductOptions = ({
  productId,
  productSlug = '',
  productName,
  productType = '',
  options,
  productInStock = false,
  isMasterclass = false,
  isFree = false,
  ebookBundleOption = null,
  isPreorder = false,
  preorderReleaseDate = null,
  showEmailNotification = true,
  hasDownloads = false,
  groupChildProducts,
  addToCartButtonText,
  addToCartButtonLinkOverride,
  brandCode = null,
}: ProductOptionsProps) => {
  const isDeckOfCards = productType.toLowerCase() === 'deck of cards'

  if (isFree && productSlug) {
    return (
      <FreeDownloadButton
        productSlug={productSlug}
        productName={productName}
        className="w-full"
      />
    )
  }
  if (addToCartButtonLinkOverride) {
    return (
      <Button href={addToCartButtonLinkOverride} className="w-full" size="lg">
        {addToCartButtonText || 'View details'}
      </Button>
    )
  }

  return (
    <AddToCartButton
      key={productId}
      productId={productId}
      productName={productName}
      options={options}
      productInStock={productInStock}
      showOptions={true}
      showEmailNotification={showEmailNotification}
      className="w-full"
      isMasterclass={isMasterclass}
      isDeckOfCards={isDeckOfCards}
      ebookBundleOption={ebookBundleOption}
      isPreorder={isPreorder}
      preorderReleaseDate={preorderReleaseDate}
      groupChildProducts={groupChildProducts}
      hasDownloads={hasDownloads}
      brandCode={brandCode}
    />
  )
}

interface ProductOptionsProps {
  productId: number
  productSlug?: string
  productName: string
  productType?: string
  options: {
    id: number
    description: string
    price: number
    salePrice?: number | null
    priceIncVat?: number | null
    salePriceIncVat?: number | null
    taxType?: number | null
    currencySymbol: string
    currencyCode?: string | null
    inStock: boolean
    productType: string
    needsShipping: boolean
  }[]
  productInStock?: boolean
  isMasterclass?: boolean
  isFree?: boolean
  ebookBundleOption?: {
    physicalOptionId: number
    downloadOptionId: number
  } | null
  isPreorder?: boolean
  preorderReleaseDate?: string | null
  showEmailNotification?: boolean
  hasDownloads?: boolean
  groupChildProducts?: GroupChildProductForCart[] | null
  addToCartButtonText?: string | null
  addToCartButtonLinkOverride?: string | null
  brandCode?: RegionalBrandCode | null
}
